<div #container class="self-explore-map">
  <section #map [ngClass]="mapPosition$ | async" class="map" data-cy="experience-self-explore-map"></section>
  <ng-container *transloco="let t; prefix: 'experience'">
    <section #overlay class="related-experiences" data-cy="related-experiences-self-explore-map">
      @for (relatedExperience of relatedExperiences; track relatedExperience; let i = $index) {
        <div class="related-experience">
          <figure>
            <img
              alt="{{ t('imageTitle', {title: relatedExperience.title}) }}"
              src="{{ relatedExperience.image | resizeImg: 560 : 300 }}"
            />
          </figure>
          <section>
            <div class="num">
              <img
                alt="{{ t('imageNumber', {imageNumber: i + 1}) }}"
                src="{{ NUMBER_URL }}{{ i + 1 | number: '2.0' }}.svg"
              />
            </div>
            <div class="content">
              <h3 class="heading-s"
                ><strong data-cy="experience-map-subcategory">{{ relatedExperience.subcategory }}</strong></h3
              >
              <h4 class="heading-xl" data-cy="map-experiences-title">{{ relatedExperience.title }}</h4>
              <p class="innerHtml" [innerHTML]="relatedExperience.description" data-cy="map-experiences-content"></p>
              <ess-button
                [buttonType]="'button'"
                class="inverted"
                (click)="navigateToExperience(relatedExperience)"
                data-cy="experience-btn-read-more"
              >
                {{ t('readMore') }}
              </ess-button>
            </div>
          </section>
        </div>
      }
    </section>
  </ng-container>
</div>
